import React from "react";

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="section-title">
          <h2>Contact</h2>
          <p>
            In the Contact section of my portfolio, I provide a seamless avenue
            for communication, welcoming inquiries, collaborations, or simply a
            friendly conversation.
            <br />
            Feel free to reach out through the provided contact form, and I'll
            be sure to respond promptly.
            <br />
            Additionally, you can connect with me through various social media
            channels for updates on my latest work and professional endeavors.
            <br />
            Your feedback and messages are valuable, and I look forward to
            engaging with you to create meaningful connections in the world of
            design and development.
          </p>
        </div>

        <div className="row" data-aos="fade-in">
          <div className="col-lg-5 d-flex align-items-stretch">
            <div className="info">
              <div className="address">
                <i className="bi bi-geo-alt"></i>
                <h4>Location:</h4>
                <p>40, Rue Ibnou Habous, Maarif, Casablanca, Morocco</p>
              </div>

              <div className="email">
                <i className="bi bi-envelope"></i>
                <h4>Email:</h4>
                <p>marouane.sanhaji@gmail.com</p>
              </div>

              <div className="phone">
                <i className="bi bi-phone"></i>
                <h4>Call:</h4>
                <p>+212 64 071 3333</p>
              </div>

              <iframe
                title="Address"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26593.1611835673!2d-7.665540633739257!3d33.5755804426379!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda7d2db38c861c3%3A0xa735763e58709a7!2s40%20Rue%20Ibnou%20Habous%2C%20Casablanca!5e0!3m2!1sen!2sma!4v1705605598460!5m2!1sen!2sma"
                style={{ border: 0, width: "100%", height: "290px" }}
                allowFullScreen
              ></iframe>
            </div>
          </div>

          <div className="col-lg-7 mt-5 mt-lg-0 d-flex align-items-stretch">
            <form
              action="https://formsubmit.co/marouane.sanhaji@gmail.com"
              method="POST"
              name="contact"
              className="email-form"
            >
              <div className="row">
                <div className="form-group col-md-6">
                  <label htmlFor="senderName">Enter your name</label>
                  <input
                    type="text"
                    name="senderName"
                    className="form-control"
                    id="senderName"
                    required
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="senderEmail">Enter your email</label>
                  <input
                    type="email"
                    className="form-control"
                    name="senderEmail"
                    id="senderEmail"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Enter a subject</label>
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  id="subject"
                  required
                />
              </div>

              <div class="form-group">
                <label htmlFor="service">Select the type of service:</label>
                <select
                  name="service"
                  id="service"
                  class="form-control"
                  required
                >
                  <option value="">Select a service</option>
                  <option value="Research">Research & Data Analysis</option>
                  <option value="Analysis">
                    Market & Competitive Analysis
                  </option>
                  <option value="Panel">Online Panel Management</option>
                  <option value="Development">
                    Software Development & Project Management
                  </option>
                  <option value="Advertising">
                    Online Marketing and Advertising
                  </option>
                  <option value="Marketing">Digital Marketing Services</option>
                  <option value="General">General Message</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Enter your message</label>
                <textarea
                  class="form-control"
                  name="message"
                  id="message"
                  rows="10"
                  required
                ></textarea>
              </div>
              <div className="text-center">
                <button type="submit">Send Message</button>
              </div>
              <input
                type="hidden"
                name="_next"
                value="https://marouanesanhaji.netlify.app/thanks.html"
              ></input>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
